var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25.0001C19.4036 25.0001 25 19.4037 25 12.5001C25 5.59656 19.4036 0.00012207 12.5 0.00012207C5.59644 0.00012207 0 5.59656 0 12.5001C0 19.4037 5.59644 25.0001 12.5 25.0001Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09375 7.90833H19.906C19.983 7.90833 20.0569 7.92237 20.1252 7.94795L12.5 13.5382L4.88198 7.94522C4.94822 7.92138 5.01955 7.90833 5.09375 7.90833ZM20.4192 8.17428C20.4925 8.27714 20.5356 8.4027 20.5356 8.53785V16.4624C20.5356 16.5999 20.491 16.7273 20.4155 16.8311L14.5242 12.4961L20.4192 8.17428ZM20.1183 17.0549C20.0519 17.0788 19.9805 17.0919 19.9061 17.0919H5.09379C5.01943 17.0919 4.94797 17.0789 4.88161 17.0549L10.778 12.716L12.3844 13.8954C12.446 13.9477 12.5375 13.9531 12.6055 13.9032L14.2231 12.7169L20.1183 17.0549ZM4.58436 16.8312C4.50887 16.7273 4.46418 16.5999 4.46418 16.4624V8.53785C4.46418 8.40033 4.50891 8.27275 4.5845 8.16889L10.477 12.4951L4.58436 16.8312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0ca8e151d38fa085d5a6a4ffddc37504.svg";
export { ForwardRef as ReactComponent };